const local={
    COUNTRY_API_URL             : "http://localhost:8080/country/",
    STATE_API_URL               : "http://localhost:8080/state/",
    PROS_SUPPLIER_API_URL       : "http://localhost:8080/supplier/",
    COMMODITY_API_URL           : "http://localhost:8080/commodity/",
    FINACIAL_API_URL            : "http://localhost:8080/financial/",
    DIVERSITY_API_URL           : "http://localhost:8080/diversity/",
    PROS_SUPNET_API_URL         : "http://localhost:8080/appparam/",
    CURRENCY_API_URL             :"http://localhost:8080/currency/",
    COMMENT_API_URL             :"http://localhost:8080/comment/",
    AUDIT_API_URL               :"http://localhost:8080/audit/"

    // COUNTRY_API_URL          : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/country/",
    // STATE_API_URL            : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/state/",
    // PROS_SUPPLIER_API_URL    : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/supplier/",
    // COMMODITY_API_URL        : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/commodity/",
    // FINACIAL_API_URL         : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/financial/",
    // DIVERSITY_API_URL        : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/diversity/",
    // PROS_SUPNET_API_URL      : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/appparam/",
    // CURRENCY_API_URL         : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/currency/",
    // COMMENT_API_URL          : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/comment/",
    // AUDIT_API_URL            : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/audit/"
}

const devl = {
    COUNTRY_API_URL          : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/country/",
    STATE_API_URL            : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/state/",
    PROS_SUPPLIER_API_URL    : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/supplier/",
    COMMODITY_API_URL        : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/commodity/",
    FINACIAL_API_URL         : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/financial/",
    DIVERSITY_API_URL        : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/diversity/",
    PROS_SUPNET_API_URL      : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/appparam/",
    CURRENCY_API_URL         : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/currency/",
    COMMENT_API_URL          : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/comment/",
    AUDIT_API_URL            : "https://prosupp.supplymgmt-devl-vpn.us.e15.c01.johndeerecloud.com/audit/"
}

const prod = {
    COUNTRY_API_URL             : "https://prospectivesupplier-api.deere.com/country/",
    STATE_API_URL               : "https://prospectivesupplier-api.deere.com/state/",
    PROS_SUPPLIER_API_URL       : "https://prospectivesupplier-api.deere.com/supplier/",
    COMMODITY_API_URL           : "https://prospectivesupplier-api.deere.com/commodity/",
    FINACIAL_API_URL            : "https://prospectivesupplier-api.deere.com/financial/",
    DIVERSITY_API_URL           : "https://prospectivesupplier-api.deere.com/diversity/",
    PROS_SUPNET_API_URL         : "https://prospectivesupplier-api.deere.com/appparam/",
    CURRENCY_API_URL            : "https://prospectivesupplier-api.deere.com/currency/",
    COMMENT_API_URL             : "https://prospectivesupplier-api.deere.com/comment/",
    AUDIT_API_URL               : "https://prospectivesupplier-api.deere.com/audit/"
  
}

const domain = window.location.hostname;
const basePathMapper = {
    'd8j24baqrhcnm.cloudfront.net': devl,
    'prospectivesupplier.tal.deere.com': devl,
    'prospectivesupplier.deere.com': prod,
    'localhost': local
};
export default basePathMapper[domain] ? basePathMapper[domain] : basePathMapper.localhost;